<template lang="pug">
  Container(
    :embed="embed",
    :className="'election-map' + (isApp ? ' isH20App' : '')",
    :titleProps="titleProps",
    :year="currentYear",
    :customAttributes="customAttributes",
    :error="error",
    :debug="debug",
    :loading="loading",
    :disclaimerConfig="disclaimerConfig"
  )
    template(#nav, v-if="embed && !hideYearNav")
      YearNav(@update:changeYear="changeYear", :year="currentYear", :embed="embed")

    .map-group( :class="{ loading: loading, comparison: compareYears }", :inset-count="insetsData.length")
      TypeaheadSearch(v-if="showSearch", :items="searchArray", @searchSelection="handleSearchSelection")
      MapColourLegend
      PartyFilters(:parties="parties" @filter:change="updatePartyFilter")
      .map-group_container
        .map-group_content(v-if="visibleYears", v-for="(yearItem, yearCount) in visibleYears", :key="yearItem.year", :i="yearCount")

          MapItem(
            :data="maps.main",
            :filters="filters",
            :year="yearItem.year",
            :triggerLoad="yearItem.loadMap",
            :triggerResultsLoad="yearItem.loadResults",
            :numInsets="insetsData.length",
            :selectedElectorate="currentSelectedElectorate",
            @update:selectedElectorate="updateElectorate"
          )

          .map-insets(v-if="insetsData && insetsData.length")
            MapItem(v-for="(insetDataItem, i) in insetsData", :key="i", :data="insetDataItem", :filters="filters", :year="yearItem.year", :numInsets="insetsData.length")

        LoadingOverlay(v-if="embed", :loading="loading")

</template>
<script>
// import components
import MapItem from '../../components/MapCore/MapItem.vue';
import LoadingOverlay from '../../components/LoadingOverlay/LoadingOverlay.vue';
import Disclaimer from '../../components/Disclaimer/Disclaimer';
import PartyFilters from '../../components/PartyFilters/PartyFilters';
import TypeaheadSearch from '../../components/TypeaheadSearch/TypeaheadSearch.vue';
import MapColourLegend from '../../components/MapColourLegend/MapColourLegend';
import Container from '../../components/Container/Container.vue';

// import mixins
import coreEmbedMixin from '../../mixins/coreEmbed';
import yearNavMixin from '../../mixins/yearNav';


const body = document.querySelector('body');

export default {
  name: 'map-group',
  mixins: [ yearNavMixin, coreEmbedMixin ],
  props: {
    insetRegion: {
      type: String
    },
    hideYearNav: {
      type: Boolean
    },
    compareYears: {
      type: Array
    },
    insets: {
      type: Array,
      default: () => ([])
    },
    selectedElectorate: {
      type: String,
    },
    showSearch: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      // maps,
      filters: {
        party: null
      },
      isApp: (body && body.attributes && body.attributes.length === 0) || document.querySelector('.screenkit--embed-container'),
      currentSelectedElectorate: this.selectedElectorate
    };
  },
  computed: {
    maps() {
      return this.$store.state.mapconfig;
    },
    electionID() {
      return this.$store.state.electionID;
    },
    insetData() {
      return this.maps[this.insetRegion];
    },
    insetsData() {
      return this.insets ? this.insets.filter(inset => {
        return inset && inset !== '_undefined_';
      }).map( inset => this.maps[inset] ) : [];
    },
    parties() {
      return this.$store.getters.parties(this.currentYear).filter(party => party.options && party.options.showInMapFilter);
    },
    visibleYears() {
      const years = (this.compareYears || [ this.currentYear ]);

      return years.map( year => {

        const
          isLoading = this.$store.state.loading,
          mapIsLoading = this.$store.state.mapLoading;

        let loadResults, loadMap;

        if (this.compareYears) {
          // If in map comparison mode, trigger loads if its not the current year and theres no data
          loadResults = ((year !== this.currentYear) && !this.$store.getters.results(year));
          // loadMap = 		((year !== this.year) && !this.$store.getters.map(year));
          loadMap = 		!mapIsLoading && !this.$store.getters.map(year);
        } else {
          // if default single map mode, trigger loads if no data, and an existing loading request isnot present.
          loadResults = !isLoading && !this.$store.getters.results(year);
          loadMap = 		!mapIsLoading && !this.$store.getters.map(year);
        }

        // console.log(`
        // 	CompareYears: ${this.compareYears},
        // 	yearIteration: ${year},
        // 	currentYear: ${this.currentYear},
        // 	isLoading: ${isLoading},
        // 	mapIsLoading: ${mapIsLoading},
        // 	shouldLoadResults: ${loadResults}
        // 	shouldLoadMap: ${loadMap},
        // 	resultDataForIterYear: ${this.$store.getters.results(year)},
        // 	mapDataForIterYear: ${this.$store.getters.map(year)}
        // `)

        return {
          year,
          loadResults,
          loadMap
        };
      }) ;
    },
    // triggerLoad() { return (this.compareYears ? true : false) },
    results() {
      return this.$store.getters.results(this.currentYear) || [];
    },
    searchArray() {
      return this.results?.Contests?.Contest || [];
    },
    customAttributes() {
      return {
        'election-id': this.electionID
      };
    }
  },
  components: { MapItem, LoadingOverlay, Container, Disclaimer, PartyFilters, TypeaheadSearch, MapColourLegend },
  methods: {
    updateElectorate(id) {
      this.currentSelectedElectorate = id;
      this.$emit('update:selectedElectorate', id);
    },
    updatePartyFilter(value) {
      this.filters.party = value;
    },
    handleSearchSelection(value) {
      console.log('handleSearchSelection', value);
      this.currentSelectedElectorate = value;
      this.updateElectorate(value);
    }
  },
  watch: {
    // currentYear: {
    //   handler(newValue, oldValue) {
    //     console.log('currentYear', newValue, oldValue, this)
    //     this.year = newValue;
    //   }
    // },
    selectedElectorate(id) {
      this.currentSelectedElectorate = id;
    }
  }
};
</script>
<style lang="scss">
@import "src/core/scss/global-sass";

.election-map {
  flex-basis: 100%;
  width: 100%;
  max-width: 100%;

  .eui-root > & {
    max-width: 705px;
  }

  &[election-embed] {

    @include MQ_SmallOnly(){
      padding: 0 $m-spacing-x2;
      margin: $m-spacing-x4 auto;
    }
    .map-group {
      padding: $m-spacing-x3 0 $m-spacing;
    }
  }

  .election-component-title {
    margin-bottom: $m-spacing;
  }

  .year-nav {
    margin-bottom: var(--spacing-unit-x2);
  }
}

.map-group {
  position: relative;
  display: flex;
  flex-direction: column;

  .eui-typeaheadSearch {
    max-width: 470px;
    margin: 0 auto var(--spacing-unit-x2);
  }

  @include MQ_TabletAndUp() {
    justify-content: center;
    flex-basis: 100%;
  }

  @include MQ_MobileOnly() {
    flex-direction:column;
    .screenkit--embed-container & {
      min-height: 200px;
      display: block;
    }
  }

  &_container {
    width: 100%;
    position: relative;
    display: flex;
  }


  .map-inset {
    box-sizing: border-box;
    position: relative;

    .map-item_wrapper {
      position: relative;
    }
  }

  .map-insets {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding-top: var(--spacing-unit-x2);
  }

  &[inset-count="3"] .map-insets .map-inset {
    flex: 0 0 30%;
    flex: 0 0 calc(33% - var(--spacing-unit-x2));
  }


}

.map-main {
  flex: 2.3 0 0;
  min-width:0;
}

.map-group_content {
  flex: 2.3 0 0;
  min-width:0;
  position: relative;
}

.eui-partyFilters {
   order: 1;
 }

@include MQ_TabletAndUp() {

  .map-group.comparison {
    .map-group_container {
      flex-wrap:wrap;
      justify-content: space-between;
    }

    .map-group_content {
      flex: 0 0 0;
      flex-basis: 50%;
      padding: 0 $m-spacing-x4;
      border-right: 3px solid #ddd;

      &[i="0"] {
        padding-left: 0;
      }

      &:last-child {
        border: none;
        padding-right: 0;
      }
    }
  }

}

@include MQ_MobileTablet() {
  .map-group.comparison {

    .map-group_container {
      margin-top: var(--spacing-unit-x4);
    }

  }
}

</style>
